import gql from 'graphql-tag'

export default gql`
  query getPayerUserSubscription {
    getPayerUserSubscription {
      email
      payerUserId
      createdAt
      updatedAt
    }
  }
`
